/* Panier v3 (21/10/2026) : recommandations sans flèches, défilement libre au trackpad, à la souris et au doigt.
   Remplace _initSwiper de pulse-sidecart.js sans modifier ce fichier. */
(function () {
  function patch() {
    var C = customElements.get('cart-drawer');
    if (!C || C.prototype.__pulseV3) return;
    C.prototype.__pulseV3 = true;
    C.prototype._initSwiper = function () {
      if (typeof Swiper === 'undefined') return;
      var c = this.querySelector('.pulse-sidecart__upsell-swiper');
      if (!c) return;
      if (this.upsellSwiper) this.upsellSwiper.destroy(true, true);
      this.upsellSwiper = new Swiper(c, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        freeMode: { enabled: true, momentum: true },
        mousewheel: { forceToAxis: true, releaseOnEdges: true },
        grabCursor: true,
        observer: true,
        observeParents: true
      });
    };
  }
  if (customElements.get('cart-drawer')) patch();
  else customElements.whenDefined('cart-drawer').then(patch);
})();

/* Panier v5 (21/10/2026) : la barre Dealeasy de livraison offerte va toujours dans l'en-tête, juste au-dessus de la date de livraison.
   Au premier affichage, Dealeasy l'insère sous l'en-tête ; elle n'était replacée qu'après une mise à jour du panier. */
(function () {
  function place(drawer) {
    var lb = drawer.querySelector('lb-cart-progress-bar');
    if (!lb) return;
    var target = drawer.querySelector('.pulse-sidecart__progress');
    if (!target) {
      var header = drawer.querySelector('.pulse-sidecart__header');
      if (!header) return;
      target = document.createElement('div');
      target.className = 'pulse-sidecart__progress';
      header.insertBefore(target, header.querySelector('.pulse-sidecart__delivery-line'));
    }
    if (lb.parentElement !== target) target.appendChild(lb);
  }
  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    place(drawer);
    new MutationObserver(function () { place(drawer); }).observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
